"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regenerateUniqueHeaders = exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _uuid = require("uuid");
var _constants = require("../constants/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = function _default(data) {
  var uuid = (0, _uuid.v4)();
  var environment = data.environment || 'test';
  _axios.default.defaults.baseURL = environment === 'live' ? _constants.BASE_URL_PROD : _constants.BASE_URL_PRE_PROD;
  _axios.default.defaults.headers.common['requestId'] = uuid;
  _axios.default.defaults.headers.common['unique-id'] = uuid;
  _axios.default.defaults.headers.post['Content-Type'] = Object.prototype.hasOwnProperty.call(data, 'contentType') ? data.contentType : 'application/json';
  _axios.default.defaults.headers.common['merchantId'] = data.paymentPlusConfig.merchantId;
};
/**
 * Few headers like requestId and unique-id needs unique reference
 * for each request. This helper function can generates unique reference
 * for such headers.
 */
exports.default = _default;
var regenerateUniqueHeaders = function regenerateUniqueHeaders() {
  var uuid = (0, _uuid.v4)();
  _axios.default.defaults.headers.common['requestId'] = uuid;
  _axios.default.defaults.headers.common['unique-id'] = uuid;
};
exports.regenerateUniqueHeaders = regenerateUniqueHeaders;